import {
  faCrown,
  faEye,
  faGear,
  faPen,
  faUserGroup,
  type IconDefinition,
} from "@fortawesome/pro-regular-svg-icons";

export type RoleState = "attn" | "brand" | "chill" | "warning" | "neutral";

// Every role and access type, with the icon and the colour it wears wherever it
// is shown (see RoleBadge). A data role looks like its counterpart among the
// management roles: admin is the owner (crown, pink), writer the maintainer
// (gear, teal), reader the viewer (eye, purple). Drafter has no counterpart and
// keeps its warning colour with a pen; a group's member role is neutral.
export const ROLES: Record<string, { icon: IconDefinition; state: RoleState }> =
  {
    // Management roles.
    owner: { icon: faCrown, state: "attn" },
    maintainer: { icon: faGear, state: "brand" },
    viewer: { icon: faEye, state: "chill" },
    // Data (access store) roles.
    admin: { icon: faCrown, state: "attn" },
    writer: { icon: faGear, state: "brand" },
    drafter: { icon: faPen, state: "warning" },
    reader: { icon: faEye, state: "chill" },
    member: { icon: faUserGroup, state: "neutral" },
  };

/** The icon of a role; an eye for a role that is not known. */
export function roleIcon(role: string): IconDefinition {
  return ROLES[role]?.icon ?? faEye;
}

/** The Bifrost colour of a role; neutral for a role that is not known. */
export function roleState(role: string): RoleState {
  return ROLES[role]?.state ?? "neutral";
}

/** The role as text: "Owner", "Reader". */
export function roleLabel(role: string): string {
  return role.charAt(0).toUpperCase() + role.slice(1);
}
